<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
  <div class="row mt-3">
    <div class="col">
      <label for="information" class="labelInformation" disabled>{{ information }}</label>
    </div>
    <div class="col btn-back text-end">
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <label for="distributorName">Distributor name<span class="required">*</span></label>
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerName" disabled />
    </div>
    <div class="col">
      <label for="address">Address</label>
      <input type="text" style="display:none" />
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerAddress" disabled />
    </div>
    <div class="col">
      <label for="city">City</label>
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerCity" disabled />
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <label for="state">State</label>
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerState" disabled />
    </div>
    <div class="col">
      <label for="postalCode">ZIP code</label>
      <input type="number" class="form-control input-label" [(ngModel)]="distributorSummary.partnerPostalCode" disabled />
    </div>
    <div class="col">
      <label for="phone">Contact number<span class="required">*</span></label>
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerPhone" disabled />
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-4">
      <label for="email">Email<span class="required">*</span></label>
      <input type="text" class="form-control input-label" [(ngModel)]="distributorSummary.partnerEmail" disabled />
    </div>
  </div>
</div>
